import microuniversoApi from "app/api/microuniversoApi";
import store from "app/redux/store/store";

declare var window: any

import globalMU from "globalMU";
import { IItemOrcamento } from "../../types/IItemOrcamento";

export type AlterarEntregaPosteriorParams = {
    itens: IItemOrcamento[],
    check?: boolean
}

export type AlterarEntregaPosteriorOutput = {
    status: "SUCESSO" | "ERRO"
}

export async function alterarEntregaPosteriorItens(params: AlterarEntregaPosteriorParams): Promise<AlterarEntregaPosteriorOutput> {
    try {
        globalMU.blockUI({ tryPassiveLoading: true })

        const orcamentoAtualizado = await microuniversoApi.Orcamento.definirEntregaPosteriorItensOrcamento(
            store.getState().orcamento.IdentificadorOrcamento,
            params.itens?.map(item => item.Identificador), 
            params.check ?? true
        )

        const orcamentoLegado = window.orcamentoController.model

        orcamentoLegado.atualizar(orcamentoAtualizado)

        return {
            status: "HasErrors" in orcamentoAtualizado ? "ERRO" : "SUCESSO"
        }

    } finally {
        globalMU.unblockUI()
    }


}
